// CONFIG
(function() {
    let c = page.config;

    // PRELOADER CONFIG
    c.preloaderParticleSpeed = 5; // nėrimo greitis preloadingo metu
    c.preloaderFadeInTime = 1500; // preloaderio atsiradimo greitis ms
    c.preloaderFadeOutTime = 500; // preloaderio išnykimo greitis ms
    c.preloaderProgressShowDelay = 2500; // preloaderio lapo su progresu atsiradimo delay ms

    // MODEL CONFIG
    c.godRayAlpha = 0.6; // godRays permatomumas

  })();
